/**
 * External File Search Agent - Tools Section
 *
 * Standard tools section with preamble and postamble from Keywords AI.
 */
import { PromptSectionBase } from '../../../base/systemPrompt/PromptSectionBase';
import { EXTERNAL_FILE_SEARCH_PROMPT_KEYS } from './variables';
/**
 * Tools preamble - introduction to available tools
 */
class ExternalFileSearchToolsPreambleSection extends PromptSectionBase {
    constructor() {
        super(...arguments);
        this.keywordsKey = EXTERNAL_FILE_SEARCH_PROMPT_KEYS.toolsPreamble;
        this.fallbackContent = `## Available Tools

You have access to searchFiles and readExcel for finding and reading content from uploaded files.`;
    }
}
/**
 * Tools postamble - closing guidance
 */
class ExternalFileSearchToolsPostambleSection extends PromptSectionBase {
    constructor() {
        super(...arguments);
        this.keywordsKey = EXTERNAL_FILE_SEARCH_PROMPT_KEYS.toolsPostamble;
        this.fallbackContent = `**Workflow:**
1. Analyze each requirement to determine the best search strategy
2. For each requirement:
   a. Search using appropriate method
   b. Review results for relevance
   c. If needed, read more details with readExcel
   d. Note the document IDs (page_xxx, excel_xxx)
3. After ALL requirements have relevant documents, call submitResults`;
    }
}
const toolsPreambleSection = new ExternalFileSearchToolsPreambleSection();
const toolsPostambleSection = new ExternalFileSearchToolsPostambleSection();
/**
 * Export constants for backwards compatibility
 */
export const EXTERNAL_FILE_SEARCH_TOOLS_PREAMBLE = toolsPreambleSection.getFallbackContent();
export const EXTERNAL_FILE_SEARCH_TOOLS_POSTAMBLE = toolsPostambleSection.getFallbackContent();
/**
 * Get the tools preamble.
 * Uses Keywords AI if available, otherwise falls back to code.
 */
export function getToolsPreamble() {
    return toolsPreambleSection.getContent();
}
/**
 * Get the tools postamble.
 * Uses Keywords AI if available, otherwise falls back to code.
 */
export function getToolsPostamble() {
    return toolsPostambleSection.getContent();
}
// ═══════════════════════════════════════════════════════════════════════════
// TOOLS SECTION BUILDER
// ═══════════════════════════════════════════════════════════════════════════
export function buildToolsSection(tools) {
    const parts = [];
    // 1. Preamble
    parts.push(getToolsPreamble());
    parts.push('');
    // 2. Individual tool descriptions
    for (const tool of tools) {
        parts.push(tool.systemPromptDescription);
        parts.push('');
    }
    // 3. Postamble
    parts.push(getToolsPostamble());
    return parts.join('\n');
}
